export const site_data = {
   "people_enabled": false,
   "site_name": "Galerie"
};